import type { ImgHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  alt: string
  width?: number
  height?: number
  priority?: boolean
  fill?: boolean
  sizes?: string
}

export default function Image({
  src,
  alt,
  width,
  height,
  priority: _priority,
  fill,
  sizes: _sizes,
  className,
  ...rest
}: ImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      className={fill ? cn('absolute inset-0 h-full w-full', className) : className}
      {...rest}
    />
  )
}
